<template>
  <div v-if="swatches.length" class="attribute-color">
    <input id="product-color" type="hidden" :value="currentColorLabel" />
    <div class="buying-zone__form-label-group">
      <div class="variantName">
        <span v-html="label" />
        <span>/</span>
        <span qaid="product-color-selected" class="text-gray-60 italic" v-html="currentColorLabel"></span
        ><span v-if="currentFinishValue">; <template v-html="currentFinishLabel" /> / </span>
        <span v-if="currentFinishValue" class="text-gray-60 italic" v-html="currentFinishValue" />
      </div>
      <pdp-stock-status
        v-if="renderStockStatus && currentColor && (!children || !children.length)"
        :stock-message="stockMessage"
      />
    </div>
    <pdl-swatch-group
      class="my-1"
      :options="swatches"
      :radio-name="`swatches-${attribute.code}`"
      :initial-selected-option="defaultColor"
      @color-changed="colorChanged"
    />
    <div v-if="currentColor && children && children.length > 0">
      <component
        :is="getAttributeComponent(children)"
        :base-properties="baseProperties"
        :product="product"
        :init-attribute-selection="initAttributeSelection"
        :label="getAttributeLabel(children)"
        :render-stock-status="renderStockStatus"
        :stock-message="stockMessage"
        :is-loading-stock-data="isLoadingStockData"
        :attribute="children"
        @color-changed="
          (color) => {
            $emit('color-changed', color);
          }
        "
        @product-selected="productSelected"
      >
      </component>
    </div>
  </div>
</template>
<script>
import {Attribute} from '@/components/containers/pdp/attributes/mixins/attribute';
import {AttributeRenderer} from '@/components/containers/pdp/attributes/mixins/attribute-renderer';
import get from 'lodash/get';
import PdpStockStatus from '@/components/containers/pdp/PdpStockStatus';
import {PdlSwatchGroup} from '@pedal/pdl-swatch';
import swatchMixin from '@/mixins/swatches.js';

export default {
  name: 'AttributeColor',
  components: {PdpStockStatus, PdlSwatchGroup},
  mixins: [Attribute, AttributeRenderer, swatchMixin],
  data() {
    return {
      currentColor: null,
    };
  },
  computed: {
    children() {
      const children = get(this.getActiveItem(), 'children', []);

      return children.sort((a, b) => {
        return a.weight > b.weight ? 1 : a.weight < b.weight ? -1 : 0;
      });
    },

    /**
     * Get human label for the current color.
     * @return {*}
     */
    currentColorLabel() {
      if (this.currentColor) {
        return get(this.getActiveItem(), 'options.displayName', '');
      }
      return '';
    },
    /**
     * Retrieve a set of swatch configurations.
     * @return {Array}
     */
    swatches() {
      if (!this.attribute) {
        return [];
      }

      let swatchArr = [];
      const metaItemCodes = this.getAttributeMetadataCodes();

      this.attribute.forEach((item) => {
        if (metaItemCodes.includes(item.code)) {
          const name = get(item, 'options.colorSwatchName');

          swatchArr.push({
            name,
            ...this.processColorCode(name),
          });
        }
      });

      return swatchArr;
    },
    /**
     * Initialize default color from given v-model or selects the first one in the list if nothing has been specified.
     */
    defaultColor() {
      if (!this.swatches.length) {
        return {};
      }

      const initSwatch = this.swatches.find((swatch) => {
        return swatch.name === get(this.initAttributeSelection, this.attribute[0].code);
      });

      if (initSwatch) {
        return initSwatch;
      } else {
        return this.swatches[0];
      }
    },
  },
  methods: {
    fireSelectedProduct() {
      const children = get(this.getActiveItem(), 'children');
      if (children && children.length > 0) {
        return;
      }

      const currentProduct = get(this.getActiveItem(), 'options');
      if (currentProduct) {
        this.productSelected(currentProduct);
      }
    },

    /**
     * Event handler, fires when user changes color via swatches.
     * @param selected
     */
    colorChanged(selected) {
      this.currentColor = selected;
      this.$emit('color-changed', selected.name);
      this.fireSelectedProduct();
    },

    /**
     * Get currently selected attribute.
     */
    getActiveItem() {
      return this.attribute.find((color) => {
        return color.options.colorSwatchName === this.currentColor?.name;
      });
    },
  },
};
</script>
